export default function AppRequirements({ carrierCalculatedShippingRegistered, webhooksRegistered }) {
    return (
        <>
            {
                carrierCalculatedShippingRegistered && webhooksRegistered
                    ? null
                    :
                    <div className="padding-bottom">
                        <h2 className="text-warning">Warning: Action Required</h2>
                        {
                            !carrierCalculatedShippingRegistered
                                ? (
                                    <div>
                                        <p>Failed to register carrier calculated shipping, this feature is required if want to show checkout windows or rates from this app at checkout.  Please contact <b>Shopify Support</b> and request for the <b>Carrier Calculated Shipping</b> feature to be enabled.</p>
                                    </div>
                                )
                                : null
                        }
                        {
                            !webhooksRegistered
                                ? (
                                    <div>
                                        <p>Failed to register Shopify webhooks.  Please visit <a href="https://urgent.co.nz" target="_blank"><b>https://urgent.co.nz</b></a> and hit the live chat button to speak with a member of the support team.</p>
                                    </div>
                                )
                                : null
                        }
                    </div>
            }
        </>
    );
}